import axios from "axios"

//let baseURL = 'http://192.168.0.22:7080/bcsa.OnboardingTarjetas.API/Onboarding/';
let baseURL = 'http://onboarding.dev.columbia.api/BCSA.onboardingTarjetas.API/Onboarding/';

export const instance = axios.create({
    baseURL: baseURL,
    timeout: 40000
});
